import "./style.scss";
import ReCAPTCHA from "react-google-recaptcha";
import { useRef } from "react";
import { useTranslation, Trans } from "react-i18next";
import { MapPinIcon, ClockIcon } from "@heroicons/react/24/outline";

export const Contact = () => {
  const { t } = useTranslation();
  const captchaRef = useRef<any>(null);

  return (
    <section className="contactSection">
      <div className="contactSection__header">
        <div className="contactSectionHeader__titleContainer">
          <div className="contactSectionHeaderTitleContainer__bar"></div>
          <div className="contactSectionHeaderTitleContainer__title">
            <h2>
              <Trans
                i18nKey="contact.title"
                components={{
                  2: <span className="highlight-word" />,
                }}
              />
            </h2>
          </div>
        </div>
      </div>
      <div className="contactSection__content">
        <div className="contactSectionContent__container">
          <div className="contactSectionContentContainer__leftColumn">
            <div className="contactSectionContentContainerLeftColumn__addressCard">
              <div className="contactSectionContentContainerLeftColumnCard__icon">
                <MapPinIcon className="icon-blue" />
                <h4>{t("contact.info.address")}</h4>
              </div>
              <div className="contactSectionContentContainerLeftColumnCard__text">
                <p>
                  30 Bd de Bellerive <br />
                  92500, Rueil-Malmaison
                </p>
                <br />
                <p>
                  6 Av. Neil Armstrong, <br />
                  33700 Mérignac
                </p>
              </div>
            </div>

            <div className="contactSectionContentContainerLeftColumn__hoursCard">
              <div className="contactSectionContentContainerLeftColumnCard__icon">
                <ClockIcon className="icon-green" />
                <h4>{t("contact.info.hours.title")}</h4>
              </div>
              <div className="contactSectionContentContainerLeftColumnCard__text">
                <p>
                  {t("contact.info.hours.text1")}
                  <br />
                  {t("contact.info.hours.text2")}
                </p>
              </div>
            </div>
          </div>

          <div className="contactSectionContentContainer__rightColumn">
            <div className="contactSectionContentContainerRightColumn__formCard">
              <form action="https://myscena.fr/contact.php" method="POST">
                <div className="contactSectionContentContainerRightColumnFormCard__inputs">
                  <div className="contactSectionContentContainerRightColumnFormCardInputs__row">
                    <div className="contactSectionContentContainerRightColumnFormCardInputs__field">
                      <label htmlFor="lastName">
                        {t("contact.form.lastname")} <span>*</span>
                      </label>
                      <input
                        type="text"
                        name="lastName"
                        id="lastName"
                        required
                      />
                    </div>
                    <div className="contactSectionContentContainerRightColumnFormCardInputs__field">
                      <label htmlFor="firstName">
                        {t("contact.form.firstname")} <span>*</span>
                      </label>
                      <input
                        type="text"
                        name="firstName"
                        id="firstName"
                        required
                      />
                    </div>
                  </div>
                  <div className="contactSectionContentContainerRightColumnFormCardInputs__row">
                    <div className="contactSectionContentContainerRightColumnFormCardInputs__field">
                      <label htmlFor="company">
                        {t("contact.form.company")} <span>*</span>
                      </label>
                      <input type="text" name="company" id="company" required />
                    </div>
                    <div className="contactSectionContentContainerRightColumnFormCardInputs__field">
                      <label htmlFor="email">
                        {t("contact.form.email")} <span>*</span>
                      </label>
                      <input type="email" name="email" id="email" required />
                    </div>
                  </div>
                  <div className="contactSectionContentContainerRightColumnFormCardInputs__field">
                    <label htmlFor="message">{t("contact.form.message")}</label>
                    <textarea name="message" id="message" rows={4} />
                  </div>
                </div>

                <div className="contactSectionContentContainerRightColumnFormCard__validation">
                  <ReCAPTCHA
                    className="captcha"
                    sitekey="6LeLtEklAAAAAAgeHPK4AAqHMVRPnGNVo9qHzDtY"
                    ref={captchaRef}
                  />
                  <div className="contactSectionContentContainerRightColumnFormCard__buttons">
                    <button className="contactSectionContentContainerRightColumnFormCardButtons__submit">
                      {t("contact.form.send")}
                    </button>
                    <button
                      type="reset"
                      className="contactSectionContentContainerRightColumnFormCardButtons__reset"
                    >
                      {t("contact.form.delete")}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {/* <div className="contactSection__remoteMeetings">
        <div className="contactSectionRemoteMeetings__image">
          <img src={meeting} alt="" />
          <div className="contactSectionRemoteMeetingsImage__wrapper">
            <div className="contactSectionRemoteMeetingsImageWrapper__title">
              <h3>Remote Meetings Suck!</h3>
            </div>
            <div className="contactSectionRemoteMeetingsImageWrapper__text">
              <p>
                Remote meetings limit our ability to connect and engage with
                each other. They lack visual dynamics and engagement to ensure
                your meetings have an impact.
              </p>
              <div className="contactSectionRemoteMeetingsImageWrapperText__subText">
                <p>
                  <span>Cluttered UI</span> – it makes it hard for your audience
                  to focus
                </p>
                <p>
                  <span>Awkward pauses</span> – hard to hold audiences’
                  attention
                </p>
                <p>
                  <span>Linear slides</span> – difficult to switch between
                  different types of content
                </p>
                <p>
                  <span>Tiny camera thumbnail</span> – disconnects you from your
                  audience and content
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="contactSection__reactivSuite">
        <div className="contactSectionReactivSuite__Background">
          <div className="contactSectionReactivSuiteImageWrapper__left">
            <div className="contactSectionReactivSuiteImageWrapper__title">
              <h3>
                When you captivate, you <br /> change minds!
              </h3>
            </div>
            <div className="contactSectionReactivSuiteImageWrapper__text">
              <p>
                ARE YOU READY TO TRANFORM YOUR NEXT <br /> REMOTE MEETING?
              </p>
            </div>{" "}
            <div className="contactSectionReactivSuiteImageWrapper__button">
              FREE DOWNLOAD
            </div>
          </div>
          <div className="contactSectionReactivSuiteImageWrapper__right">
            <div className="contactSectionReactivSuiteImageWrapper__logo">
              <img src={logoScena} alt="" />
            </div>
          </div>
        </div>
      </div> */}
    </section>
  );
};
